import { InventoryTypeFieldOptionMessage } from "./InventoryTypeFieldOptionMessage"

export class UpdateInventoryTypeFieldMessage {
  name: string
  displayOrder: number
  isRequired: boolean

  inventoryTypeFieldOptions: InventoryTypeFieldOptionMessage[]

  constructor(name: string, displayOrder: number, isRequired: boolean, inventoryTypeFieldOptions: InventoryTypeFieldOptionMessage[]) {
    this.name = name
    this.displayOrder = displayOrder
    this.isRequired = isRequired
    this.inventoryTypeFieldOptions = inventoryTypeFieldOptions
  }
}